import { observer, useLocalObservable } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import StoreTranslate from 'GlobalStores/Cores/Translator/StoreTranslate'
import mobiscroll from '@mobiscroll/react'
import '@mobiscroll/react/dist/css/mobiscroll.react.scss'
import './MobiSelectStates.css'
import { reaction, runInAction, toJS } from 'mobx'
import { ReactComponent as DropdownIcon } from '../Assets/dropdown.svg'
import { storeElement } from 'GlobalStores/StoreElement'
import { Stack } from '@mui/material'
import { get, isEmpty, keyBy, lowerCase } from 'lodash'
import { DefaultLabelTypo } from '../InputsStyled'
import storeCheckout from 'GlobalStores/Checkout/StoreCheckout'
import { useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'
import DefaultInput from '../DefaultInput'
import { isIOS } from 'Helpers/Bowser'

const MobiSelectStates = observer(({ item, label, allItems, forceType }) => {
    const [options, setOptions] = useState([])
    const [isReady, setIsReady] = useState(false)
    const translate = useTranslate()

    const localObserver = useLocalObservable(() => ({
        listForRender: [],
        value: ''
    }))

    const renderProvinces = async () => {
        try {
            runInAction(() => {
                localObserver.listForRender = []
            })

            let list = []
            list = options.map(province => {
                return {
                    value: province,
                    text: province
                }
            })

            runInAction(() => {
                localObserver.listForRender = list
            })

            setPropValueToState(localObserver.value)
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        renderProvinces()
    }, [options])

    const setPropValueToState = propValue => {
        if (propValue) {
            let val = lowerCase(propValue)
            runInAction(() => {
                localObserver.listForRender.map(l => {
                    if (lowerCase(l.text).includes(val)) {
                        localObserver.value = l.value
                    }
                    return l
                })
            })
        }
    }

    useEffect(() => {
        let data = []
        data = storeCheckout
            .CheckOutInstance()
            .Instance()
            .AddressOptionList(item.key, storeCheckout)
            .map(i => i.value)
        setOptions(data)

        const disposer = reaction(
            () => storeCheckout.CheckOutInstance().Instance().AddressOptionList(item.key, storeCheckout),
            (n, p) => {
                if (n !== p) {
                    let data = []

                    data = storeCheckout
                        .CheckOutInstance()
                        .Instance()
                        .AddressOptionList(item.key, storeCheckout)
                        .map(i => i.value)

                    setOptions(data)
                }
            }
        )

        const disposerLang = reaction(
            () => StoreTranslate.CurrentLanguage(),
            (n, p) => {
                if (n !== p) {
                    storeCheckout.SetCheckoutFormValue(item.key, '')
                    renderProvinces()
                }
            }
        )

        return () => {
            disposer()
            disposerLang()
        }
    }, [])

    useEffect(() => {
        if (localObserver.listForRender.length > 0) {
            setTimeout(() => {
                setIsReady(true)
            }, 1500)
        }
    }, [localObserver.listForRender.length])

    useEffect(() => {
        if (item.value) {
            if (localObserver.listForRender.length > 0) {
                setPropValueToState(item.value)
            } else if (localObserver.listForRender.length === 0) {
                renderProvinces()
                setPropValueToState(item.value)
            }
        } else {
            if (localObserver.listForRender.length === 0) {
                renderProvinces()
            }
        }
    }, [item.value, localObserver.listForRender.length])

    const onSelected = (event, inst) => {
        if (event?.valueText) {
            storeCheckout.SetCheckoutFormValue(item.key, event.valueText)
        }
    }

    const onNativeSelect = (e) => {
        storeCheckout.SetCheckoutFormValue(item.key, e.target.value)
    }

    const renderIOSSelect = () => (
        <Stack className="mobi-custom-input" sx={{ position: 'relative' }}>
            <select
                value={item.value || ''}
                onChange={onNativeSelect}
                disabled={isEmpty(localObserver.listForRender) || !isReady}
                style={{
                    width: '100%',
                    height: '48px',
                    padding: '0 40px 0 16px',
                    fontSize: '16px',
                    border: '1px solid var(--input-border)',
                    borderRadius: '8px',
                    backgroundColor: 'white',
                    appearance: 'none',
                    WebkitAppearance: 'none',
                    cursor: 'pointer',
                    color: item.value ? '#153862' : 'rgba(21, 56, 98, 0.5)'
                }}>
                <option value="" disabled>
                    {translate(item.placeholder)}
                </option>
                {toJS(localObserver.listForRender).map(opt => (
                    <option key={opt.value} value={opt.value}>
                        {opt.text}
                    </option>
                ))}
            </select>
            <Stack position={'absolute'} right={'15px'} top={'50%'} sx={{ transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                <DropdownIcon className={`${isEmpty(options) ? 'dropdown-icon-disabled' : ''}`} style={{ color: 'var(--input-border)' }} />
            </Stack>
        </Stack>
    )

    const renderMobiscrollSelect = () => (
        <Stack className={`mobi-custom-input ${isEmpty(options) ? 'mbsc-disabled-select' : ''}`} sx={{ cursor: 'pointer', '.mbsc-input-wrap input': { cursor: 'pointer' } }}>
            <mobiscroll.Select
                className={item.key}
                key={item.key}
                display="center"
                touchUi={false}
                filter={true}
                height={40}
                placeholder={translate(item.placeholder)}
                maxWidth={400}
                data={toJS(localObserver.listForRender)}
                onSet={(e, inst) => onSelected(e, inst)}
                value={item.value}
                disabled={isEmpty(localObserver.listForRender) || !isReady}
                filterPlaceholderText=""
                group={{
                    groupWheel: false,
                    header: false
                }}
                filterEmptyText={translate('select_filter_no_result_text')}>
                <mobiscroll.Input className="disabled" style={{ cursor: 'pointer' }}>
                    <Stack position={'absolute'} right={'15px'} top={'45%'} zIndex={1}>
                        <DropdownIcon className={`${isEmpty(options) ? 'dropdown-icon-disabled' : ''}`} style={{ cursor: 'pointer', color: 'var(--input-border)' }} />
                    </Stack>
                </mobiscroll.Input>
            </mobiscroll.Select>
        </Stack>
    )

    return (
        <Stack>
            <div
                style={{
                    display: 'flex',
                    justifyContent: storeElement.dynamicWidth > 768 && 'space-between',
                    marginBottom: '8px',
                    paddingLeft: '16px'
                }}>
                <label>
                    <DefaultLabelTypo variant="label">
                        {label}
                        {item.showRequiredMark ? <span> *</span> : null}
                    </DefaultLabelTypo>
                </label>
            </div>

            {isIOS() ? renderIOSSelect() : renderMobiscrollSelect()}
        </Stack>
    )
})

export default MobiSelectStates
